/** Local image paths under public/images/{folder} */
export function shelfImages(folder, names = {}) {
  const base = `${process.env.PUBLIC_URL || ""}/images/${folder}`;
  const defaults = {
    hero: `${base}/hero.jpg`,
    cardCover: `${base}/card-cover.jpg`,
    figure1: `${base}/figure-1.jpg`,
    figure2: `${base}/figure-2.jpg`,
    figure3: `${base}/figure-3.jpg`,
  };
  return { ...defaults, ...names };
}
